export default "__VITE_ASSET__nE9LIXU2__"